'use client';
import editorEventsBus from 'lowcode/utils/editorEventsBus';
import React, { useEffect, useRef, useState } from 'react';
import './index.scss';
export const getTraceId = (num = 32) => {
    const val2 = `${Math.random()}`.slice(2);
    const val3 = `${Math.random()}`.slice(2);
    const val4 = `${Math.random()}`.slice(2);
    const val5 = `${Math.random()}`.slice(2);
    return `${val2}${val3}${val4}${val5}`.slice(0, num);
};

interface EfMessageItemProps {
    /**
     * 文案
     */
    title: string;
    /**
     * 样式
     */
    type: string;
    /**
     * 用于删除的建
     */
    _timerId: string;
}

interface EfMessage {
    /**
     * 样式名
     */
    className?: string;
}

export const EfMessageGlobal: React.FC<EfMessage> = ({}) => {
    const prefixCls = `ef-message`;
    const itemsRef = useRef<EfMessageItemProps[]>([]);
    const [items, setItems] = useState<EfMessageItemProps[]>([]); //消息列表

    useEffect(() => {
        editorEventsBus.on('ef-message-add', (item: EfMessageItemProps) => {
            const items2 = JSON.parse(JSON.stringify(itemsRef.current));
            items2.push(item);
            itemsRef.current = items2;
            setItems(items2);
        });
    }, []);

    return (
        <div className={prefixCls}>
            {items.map((item: EfMessageItemProps, index: number) => {
                return (
                    <div className={`${prefixCls}-item ${prefixCls}-item-type-${item.type}`} key={item._timerId || index}>
                        {item.title}
                    </div>
                );
            })}
        </div>
    );
};

const EfMessageApi = () => {
    // 成功
    const successHandle = (title?: string) => {
        if (title) {
            editorEventsBus.emit('ef-message-add', {
                title: title,
                type: 'success',
                _timerId: getTraceId(16),
            });
        }
    };
    // 失败
    const errorHandle = (title?: string) => {
        if (title) {
            editorEventsBus.emit('ef-message-add', {
                title: title,
                type: 'error',
                _timerId: getTraceId(16),
            });
        }
    };
    return {
        success: successHandle,
        error: errorHandle,
    };
};
export default EfMessageApi();
